export default "__VITE_ASSET__DWz2vx6r__"